import { useChartCtx } from '@weenat/client/dist/core/charts'
import { memo } from 'react'
import { useTheme } from 'styled-components'

const LOCK_SIZE = 24

function RestrictedArea() {
  const { xScale, marginTop, marginLeft, marginRight, height, width, marginBottom } = useChartCtx()

  const { colors } = useTheme()
  const xRange = xScale.range()

  const nowInPx = xScale(new Date())

  const endOfArea = nowInPx < xRange[1] && nowInPx > 0 ? nowInPx : width - marginRight

  const rectWidth = endOfArea - marginLeft
  const rectHeight = height - marginBottom - marginTop

  const transform = `translate(${marginLeft},${marginTop})`

  return (
    <g transform={transform}>
      <rect x='0' y='0' width={rectWidth} height={rectHeight} fill={colors.grayscale.white} />
      <path
        transform={`translate(${(rectWidth - LOCK_SIZE) / 2},${(rectHeight - LOCK_SIZE) / 2})`}
        d='M6 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20V10c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 8h1V6c0-1.383.487-2.563 1.463-3.538C9.438 1.487 10.617 1 12 1s2.563.488 3.537 1.462C16.512 3.438 17 4.617 17 6v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 18 22H6Zm6-5c.55 0 1.02-.196 1.412-.587.392-.392.588-.863.588-1.413s-.196-1.02-.588-1.412A1.926 1.926 0 0 0 12 13c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 10 15c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587ZM9 8h6V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 6v2Z'
      />
    </g>
  )
}

export default memo(RestrictedArea)
